import React from 'react';
import SupplierForm from '../../components/SupplierForm';

const AddSupplier: React.FC = () => <SupplierForm />;

export default AddSupplier;
